import { RouterModule, Routes } from '@angular/router'

import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component'
import { NgModule } from '@angular/core'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
   {
    path: 'contact',
    component: ContactComponent,
    pathMatch: 'full'
  },
  {
    path: 'counter',
    loadChildren:()=>import('./pages/counter/counter.module').then(m=>m.CounterModule),
    pathMatch: 'full'
  },
  {
    path:':key',
    loadChildren:() =>import('./pages/page-inner/page-inner.module').then(m=>m.PageInnerModule)
  },

  {
    path: '**',
    component: HomeComponent
  }
]

@NgModule({
  imports: [
      RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
